import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withKeys as _withKeys, createVNode as _createVNode, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/titleIcon2.png'
import _imports_1 from '@/assets/images/no-data.png'


const _withScopeId = n => (_pushScopeId("data-v-d0e3379a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "packageDependency-container sbom-container" }
const _hoisted_2 = { class: "package-title" }
const _hoisted_3 = { class: "title" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_5 = { class: "search" }
const _hoisted_6 = { class: "sbom-table" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "no-data" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    alt: ""
  }),
  /*#__PURE__*/_createElementVNode("p", null, "暂无相关内容")
], -1))
const _hoisted_8 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.config, (part, partIndex) => {
      return (_openBlock(), _createElementBlock("div", {
        class: "package-main",
        key: partIndex
      }, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _hoisted_4,
            _createTextVNode(" " + _toDisplayString(part.title), 1)
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_el_input, {
              placeholder: "请输入namespace或name，按enter键搜索",
              "suffix-icon": _ctx.Search,
              modelValue: _ctx.search[part.prop],
              "onUpdate:modelValue": ($event: any) => ((_ctx.search[part.prop]) = $event),
              onBlur: _ctx.getData,
              onKeyup: _withKeys(_ctx.getData, ["enter"])
            }, null, 8, ["suffix-icon", "modelValue", "onUpdate:modelValue", "onBlur", "onKeyup"])
          ])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_el_table, {
            data: _ctx.tableData[part.prop],
            stripe: "",
            border: "",
            "highlight-current-row": ""
          }, {
            empty: _withCtx(() => [
              _hoisted_7
            ]),
            default: _withCtx(() => [
              _createVNode(_component_el_table_column, {
                type: "index",
                label: "编号",
                width: "80"
              }),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.columns[part.prop], (col, colIndex) => {
                return (_openBlock(), _createBlock(_component_el_table_column, {
                  key: colIndex,
                  label: col.label,
                  "show-overflow-tooltip": "",
                  "class-name": col.prop === 'qualifiers' ? 'cell-list' : ''
                }, {
                  default: _withCtx((scope) => [
                    (col.prop === 'qualifiers' && scope.row[col.prop])
                      ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(scope.row[col.prop], (item, key) => {
                          return (_openBlock(), _createElementBlock("div", { key: key }, [
                            _createElementVNode("span", null, _toDisplayString(key) + ": ", 1),
                            _createElementVNode("span", null, _toDisplayString(item), 1)
                          ]))
                        }), 128))
                      : (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(scope.row[col.prop]), 1))
                  ]),
                  _: 2
                }, 1032, ["label", "class-name"]))
              }), 128))
            ]),
            _: 2
          }, 1032, ["data"])
        ])
      ]))
    }), 128))
  ]))
}